import { createReducer } from '@topconagriculture/frontend-utils';

import { getClDevices, getFeedSubscriptionExpiration } from './subscription.actions';
import { CloudLynk, SubscriptionInfo } from './subscription.types';

export type SubscriptionState = {
  readonly subscriptions: SubscriptionInfo[];
  readonly cloudLynkDevices: CloudLynk[];
};

const initialState: SubscriptionState = {
  subscriptions: [],
  cloudLynkDevices: [],
};

const subscriptionReducer = createReducer(initialState, {
  [getFeedSubscriptionExpiration.done.type]: (
    state: SubscriptionState,
    action: ReturnType<typeof getFeedSubscriptionExpiration.done>,
  ) => {
    return {
      ...state,
      subscriptions: action.payload.result,
    };
  },
  [getClDevices.done.type]: (state: SubscriptionState, action: ReturnType<typeof getClDevices.done>) => {
    return {
      ...state,
      cloudLynkDevices: action.payload.result,
    };
  },
});

export default subscriptionReducer;
